import { render, staticRenderFns } from "./TituloContas.vue?vue&type=template&id=74530ab1&"
import script from "./TituloContas.vue?vue&type=script&lang=js&"
export * from "./TituloContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports